import { styled } from '@frontend/theme';
import { MenuItem as MenuItemBase } from '@frontend/ui-elements';
import { Container as MUIContainer } from '@mui/material';

export const Container = styled(MUIContainer)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: 0,
});

export const MenuItem = styled(MenuItemBase)(({ theme }) => ({
  gap: '8px',
  padding: '0 8px',
  position: 'relative',
  '&:not(:last-of-type)::after': {
    backgroundColor: `${theme.palette.neutral[50]}`,
    content: '""',
    width: 'calc(100% - 16px)',
    height: '1px',
    position: 'absolute',
    left: '8px',
    bottom: '0',
  },

  [theme.breakpoints.down('tabletL')]: {
    padding: '0',

    '&:not(:last-of-type)::after': {
      width: '100%',
      left: 0,
    },
  },
}));
